export default "__VITE_ASSET__893f97f4__"